import { render, staticRenderFns } from "./ModalValidate.vue?vue&type=template&id=7e20961c"
import script from "./ModalValidate.vue?vue&type=script&lang=js"
export * from "./ModalValidate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports